type ExternalAuthEndpoint = '/auth' | '';

export function getAuthEndpointForExternalIntegration(
  gameId: number,
  externalGameTypes: number[]
): ExternalAuthEndpoint {
  return externalGameTypes.includes(gameId) ? '/auth' : '';
}
